import React, { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import FormTextField from "../../../components/textField/formTextField";

const InstitutionSection = ({
  control,
  setValue,
  errors,
  data
}) => {

  const loadData = () => {
    setValue("institution", data.institutionName || "");
    setValue("city", data.cityName || "");
    setValue("phone", data.phone || "");
    setValue("address", data.address || "");
  };

  useEffect(() => {}, []);

  useEffect(() => {
    if (!data) return;
     loadData();
  }, [data]);

  return (
    <div>
      <Grid container justifyContent="center" spacing={2}>
        <Grid item xs={12} md={6}>
          <p className="create-label ml-0">Nombre de la Institución:</p>
          <FormTextField
            name="institution"
            control={control}
            label=""
            disabled
            margin={"0"}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <p className="create-label ml-0">Ciudad:</p>
          <FormTextField
            name="city"
            control={control}
            label=""
            disabled
            margin={"0"}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <p className="create-label ml-0 label-no-top-margin">Contacto:</p>
          <FormTextField
            name="phone"
            control={control}
            label=""
            error={errors.phone}
            disabled
            margin={"0"}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <p className="create-label ml-0 label-no-top-margin">Dirección:</p>
          <FormTextField
            name="address"
            control={control}
            label=""
            error={errors.address}
            disabled
            margin={"0"}
          />
        </Grid>
      </Grid>
    </div>
  );
};

export default InstitutionSection;
